import { useState, useEffect } from 'react';
import styles from '../../DashboardComponents/Main/RightPanel/RightPanel.module.css'
import { ReactComponent as IconPlay } from '../../DashboardComponents/Main/assets/icon-play.svg';
import { ReactComponent as IconPause } from '../../DashboardComponents/Main/assets/icon-pause.svg';
import { ReactComponent as IconStop } from '../../DashboardComponents/Main/assets/icon-stop.svg';

const Chronometer = ({
    parameterData,
    setParameterData,
    handleChange,
    editingInput,
    setEditingInput,
  }) => {

    
  return (
    <div>
       <MediaControls
        parameterData={parameterData}
        setParameterData={setParameterData}
      />
    </div>
  )
}

export default Chronometer


const MediaControls = ({ parameterData, setParameterData }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [isStopped, setIsStopped] = useState(false);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) return `${hours}h${minutes.toString().padStart(2, "0")}m`;
    if (minutes > 0) return `${minutes}m${secs.toString().padStart(2, "0")}s`;
    return `${secs}s`;
  };

  const calculateElapsedTime = () => {
    const startTime = localStorage.getItem("startTime");
    const baseTime = parseInt(localStorage.getItem("baseTime") || "0");
    if (!startTime) return baseTime;
    const now = Date.now();
    return baseTime + Math.floor((now - parseInt(startTime)) / 1000);
  };

  const handlePlay = () => {
    if (isStopped) {
      setIsStopped(false);
      localStorage.setItem("isStopped", "false");
      setParameterData((prev) => ({ ...prev, elapsedTime: 0 }));
      localStorage.setItem("mediaTimer", "0");
      localStorage.setItem("baseTime", "0");
    }

    if (!isPlaying) {
      const startTime = Date.now();
      localStorage.setItem("startTime", startTime.toString());

      const id = setInterval(() => {
        const currentElapsed = calculateElapsedTime();
        setParameterData((prev) => ({
          ...prev,
          elapsedTime: currentElapsed,
        }));
        localStorage.setItem("mediaTimer", currentElapsed.toString());
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
      setIntervalId(null);
    }

    setIsPlaying((prev) => !prev);
  };

  const handlePause = () => {
    if (isStopped || !isPlaying) return;

    clearInterval(intervalId);
    setIntervalId(null);
    setIsPlaying(false);

    const currentElapsed = calculateElapsedTime();
    localStorage.setItem("baseTime", currentElapsed.toString());
    localStorage.removeItem("startTime");
  };

  const handleStop = () => {
    if (isStopped) return;

    clearInterval(intervalId);
    setIntervalId(null);
    setIsPlaying(false);
    setIsStopped(true);
    localStorage.setItem("isStopped", "true");
    localStorage.removeItem("startTime");
    localStorage.removeItem("baseTime");
    alert(`Tiempo total: ${formatTime(parameterData.elapsedTime || 0)}`);
    setParameterData((prev) => ({ ...prev, elapsedTime: 0 }));
    localStorage.setItem("mediaTimer", "0");
  };

  useEffect(() => {
    const savedStoppedState = localStorage.getItem("isStopped");
    const startTime = localStorage.getItem("startTime");
    const baseTime = parseInt(localStorage.getItem("baseTime") || "0");

    if (savedStoppedState === "true") {
      setIsStopped(true);
      setIsPlaying(false);
      setParameterData((prev) => ({ ...prev, elapsedTime: 0 }));
    } else if (!startTime && baseTime > 0) {
      setParameterData((prev) => ({ ...prev, elapsedTime: baseTime }));
      setIsPlaying(false);
    } else if (startTime) {
      const currentElapsed = calculateElapsedTime();
      setParameterData((prev) => ({ ...prev, elapsedTime: currentElapsed }));

      const id = setInterval(() => {
        const newElapsed = calculateElapsedTime();
        setParameterData((prev) => ({
          ...prev,
          elapsedTime: newElapsed,
        }));
        localStorage.setItem("mediaTimer", newElapsed.toString());
      }, 1000);
      setIntervalId(id);
      setIsPlaying(true);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  return (
    <div className={styles.mediaControls}>
      <button
        className={`${styles.mediaBtn} ${styles.play}`}
        onClick={handlePlay}
        title="Play"
        style={{ opacity: isStopped ? 0.5 : 1 }}
      >
        <IconPlay />
      </button>
      <button
        className={`${styles.mediaBtn} ${styles.pause}`}
        onClick={handlePause}
        title="Pause"
        style={{ opacity: !isPlaying || isStopped ? 0.5 : 1 }}
      >
        <IconPause />
      </button>
      <button
        className={`${styles.mediaBtn} ${styles.stop}`}
        onClick={handleStop}
        title="Stop"
        style={{ opacity: isStopped ? 0.5 : 1 }}
      >
        <IconStop />
      </button>
      <div
        className={`${styles.timerDisplay} ${
          isPlaying ? styles.playing : styles.paused
        }`}
      >
        <span className={styles.timeHour}>
          {formatTime(parameterData.elapsedTime || 0)}
        </span>
      </div>
    </div>
  );
};

